// extracted by mini-css-extract-plugin
module.exports =  {"section":"bFJqnte","equal-padding":"k6rERL0","equalPadding":"k6rERL0","fluid":"zKIeGM9"};